import { fullName } from 'src/utils/data/user';
import useVersion from './useVersion';

const statusParser = status => {
  if (status === 'published') {
    return 'Current version';
  }
  if (status === 'draft') {
    return 'Draft';
  }

  return status;
};

export default ({ versions, users, titleAttribute = 'name' }) => {
  const [{ version }, { handleVersionSelect }] = useVersion(versions);

  const versionItems = versions
    .map(v => ({
      id: v.id,
      version: v.version,
      title:
        typeof titleAttribute === 'function'
          ? titleAttribute(v)
          : v[titleAttribute],
      user: fullName(users.find(u => +u.id === +v.createdById) || {}),
      current: v.id === version.id,
      createdAt: v.createdAt,
      updatedAt: v.updatedAt,
      deletedAt: v.deletedAt,
      status: statusParser(v.status),
    }))
    .sort((a, b) => {
      if (a.status === 'Draft') return 1;
      if (b.status === 'Draft') return -1;
      return a.version - b.version;
    });

  return [{ version, versionItems }, { handleVersionSelect }];
};
